const DEVICE_TOKEN_STORAGE_KEY = '_snap_device_token';

export function getOrCreateDeviceToken(): string {
  if (typeof localStorage === 'undefined') {
    return '';
  }

  const existing = localStorage.getItem(DEVICE_TOKEN_STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const token =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  localStorage.setItem(DEVICE_TOKEN_STORAGE_KEY, token);
  return token;
}

export function persistDeviceToken(token: string | null | undefined): void {
  if (!token || typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem(DEVICE_TOKEN_STORAGE_KEY, token);
}

export { DEVICE_TOKEN_STORAGE_KEY };
